import img1 from '../img/WhyMeCard/milkyway_w640.jpg';
import img2 from '../img/WhyMeCard/resort_w640.jpg';
import img3 from '../img/WhyMeCard/trees_w640.jpg';


export const whyMeList = [
    {
        img: img1,
        imgAlt: "Widok Drogi Mlecznej podkreślający wizualny aspekt karty.",
        title: "Elastyczność, na której możesz polegać",
        description: "Każdy projekt to indywidualne wyzwanie. Dostosowuję się do Twojego harmonogramu, budżetu i oczekiwań, by znaleźć rozwiązanie, które najlepiej odpowiada Twoim potrzebom.",

    },
    {
        img: img2,
        imgAlt: "Zdjęcie pola lawendowego podkreślające wizualny aspekt karty.",
        title: "Indywidualne podejście do każdego projektu",
        description: "Nie jestem korporacją, gdzie klient jest tylko kolejnym numerem. Każdy projekt traktuję z pełnym zaangażowaniem i uwagą, bo wiem, że Twoja strona jest odzwierciedleniem Twojej marki.",

    },
    {
        img: img3,
        imgAlt: "Drzewa na tle gór, podkreślające wizualny aspekt karty.",
        title: "Wsparcie na każdym etapie projektu",
        description: "Pomogam określić cel, zaprojektować wygląd i wdrożyć rozwiązania. Po zakończeniu projektu nadal oferuję wsparcie, aby Twoja strona mogła rosnąć razem z Twoim biznesem.",

    },
]